import React, { useState } from "react";
import { RiStackLine } from "react-icons/ri";
import { RiArrowDownLine } from "@remixicon/react";
import { DashboardGroupBy } from "../../../__generated__/api";
import Dropdown from "../../theme/dropdown/Dropdown";
import Styles from "./BoardToolbar.module.scss";

const GROUP_BY_TO_NAME = [
    { groupBy: DashboardGroupBy.Assignee, label: "Assignee" },
    { groupBy: DashboardGroupBy.Channel, label: "Channel" },
    { groupBy: DashboardGroupBy.CompanyGroup, label: "Company/Group" },
    { groupBy: DashboardGroupBy.Priority, label: "Priority" },
    { groupBy: DashboardGroupBy.Queue, label: "Queue" },
    { groupBy: DashboardGroupBy.User, label: "Requester" },
];

export default function GroupByFilter({
    onChange,
    value,
    shouldShowExpand,
}: {
    onChange: (filter: DashboardGroupBy) => void;
    value: DashboardGroupBy | undefined;
    shouldShowExpand?: boolean;

}) {
    const [shouldShow, setShouldShow] = useState(false);
    return (
        <Dropdown autoClose="outside" show={shouldShow} onToggle={() => setShouldShow(!shouldShow)}>
            <Dropdown.Toggle
                variant="filter"
                prefixIcon={<RiStackLine />}
                onClick={() => {
                    setShouldShow(!shouldShow);
                }}
                postfixIcon={shouldShowExpand ? <RiArrowDownLine /> : undefined}
                className="d-flex align-items-center w-100 text-start"
                isActive={value && value !== DashboardGroupBy.NoGroup}
            >
                <div className="flex-grow-1">
                    <span className="text-dim">Group by:</span>
                    {" "}
                    {(value ? GROUP_BY_TO_NAME.find(group => group.groupBy === value)?.label : undefined) ?? "None"}
                </div>
            </Dropdown.Toggle>
            <Dropdown.Menu className={`${Styles["panel-filters"]}`}>
                {GROUP_BY_TO_NAME.map(group => (
                    <Dropdown.Item
                        key={group.groupBy}
                        isActive={value === group.groupBy}
                        isChecked={value === group.groupBy}
                        onClick={() => {
                            onChange(group.groupBy);
                            setShouldShow(false);
                        }}
                    >
                        {group.label}
                    </Dropdown.Item>
                ))}

                <Dropdown.Divider />
                <Dropdown.Item
                    onClick={() => {
                        onChange(DashboardGroupBy.NoGroup);
                        setShouldShow(false);
                    }}
                >
                    Don&apos;t Group
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}

GroupByFilter.defaultProps = {
    shouldShowExpand: false,
};
